import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { API_URL, BASE_URL } from "../Config";
import config from "../common/Config";
import { toast } from "sonner";
import CommonDatePicker from "../datepicker/CommonDatePicker";
import { format } from "date-fns";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  IconButton,
  InputAdornment,
  Checkbox,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Link as MuiLink,
  Skeleton,
  Chip,
  Grid2,
} from "@mui/material";
import { Iconify } from "../Minimal/src/components/iconify/iconify";

const Proforma = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [newSales, setNewSales] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const accessToken = localStorage.getItem("accessToken");
  const roleID = localStorage.getItem("roleID");
  const [salesDates, setSalesDates] = useState([null, null]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rejectReason, setRejectReason] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedOrderForMenu, setSelectedOrderForMenu] = useState(null);

  useEffect(() => {
    fetchData(fromDate, toDate);
  }, [fromDate, toDate, rowsPerPage, page, searchValue, accessToken]);

  const handleSubmitDates = (value) => {
    const [startDate, endDate] = value;
    let formattedStartDate = "";
    let formattedEndDate = "";

    if (startDate) {
      const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
      formattedStartDate = format(start, "MM/dd/yyyy");
    }

    if (endDate) {
      const end = typeof endDate === 'string' ? new Date(endDate) : endDate;
      formattedEndDate = format(end, "MM/dd/yyyy");
    }

    fetchData(formattedStartDate, formattedEndDate);
  };

  const fetchData = async (startDate, endDate) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("draw", page + 1);
      formData.append("start", page * rowsPerPage);
      formData.append("length", rowsPerPage);
      formData.append("searchByFromdate", startDate || fromDate || "");
      formData.append("searchByTodate", endDate || toDate || "");
      formData.append("search[value]", searchValue || "");

      const response = await fetch(`${config.API_URL}/proforma/invoice`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const json = await response.json();

      if (json?.data && Array.isArray(json.data)) {
        setNewSales(json.data);
        setTotalRecords(json.recordsTotal || json.recordsFiltered || json.data.length);
      } else {
        setNewSales([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
      setNewSales([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };


  const handleMenuOpen = (event, order) => {
    event.stopPropagation();
    setMenuAnchor(event.currentTarget);
    setSelectedOrderForMenu(order);
  };

  const handleMenuClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setMenuAnchor(null);
    setSelectedOrderForMenu(null);
  };

  const handleRejectAction = () => {
    if (selectedOrderForMenu) {
      setSelectedOrder(selectedOrderForMenu);
      setShowRejectModal(true);
    }
    handleMenuClose();
  };

  const updateReject = async (event) => {
    event.preventDefault();

    if (!selectedOrder || !rejectReason.trim()) {
      toast.error("Please enter a reason for rejection.");
      return;
    }

    const orderId = selectedOrder.id;
    const reason = rejectReason;

    const formData = new FormData();
    formData.append("status", "Reject");
    formData.append("reason_note", reason);
    formData.append("id", orderId);
    formData.append("new-sales", 'No');
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    try {
      const response = await fetch(`${config.API_URL}/ws-update-status`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP error! Status: ${response.status}. Error: ${errorText}`
        );
      }

      const data = await response.json();

      toast.success("Order rejected successfully.");
      setShowRejectModal(false);
      setRejectReason("");
      setTimeout(() => {
        window.location.href = config.BASE_URL + "/picking/proforma/";
      }, 500);
    } catch (error) {
      toast.error("Error rejecting order. Please try again.");
    }
  };



  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    const selectableOrders = newSales.filter(order => order.invoice_total && Number(order.invoice_total) !== 0);
    
    if (isChecked) {
      const allIds = selectableOrders.map(order => order.id);
      setSelectedOrders(allIds);
      setSelectedCount(allIds.length);
    } else {
      setSelectedOrders([]);
      setSelectedCount(0);
    }
  };

  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prev) => {
      if (prev.includes(orderId)) {
        const updated = prev.filter(id => id !== orderId);
        setSelectedCount(updated.length);
        return updated;
      } else {
        const updated = [...prev, orderId];
        setSelectedCount(updated.length);
        return updated;
      }
    });
  };


  const handleConfirmOrders = async () => {
    if (selectedOrders.length === 0) {
      toast.error('Please select at least one order.');
      return;
    }

    try {
      const response = await fetch(`${config.API_URL}/confirm-orders`, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ order_ids: selectedOrders }),
      });

      if (!response.ok) throw new Error('API error');
      await response.json();

      toast.success('Orders confirmed!');
      setSelectedOrders([]);
      setSelectedCount(0);
      fetchData();
    } catch (err) {
      toast.error('Failed to confirm orders.');
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
    setSearchValue(value);
    setPage(0);
  };



  return (
    <div>
      {/* <Header /> */}
      <Box sx={{ width: "100%", px: { xs: 2, md: 3 }, py: 2, backgroundColor: "#f5f7fa", height: "calc(100vh - 110px)" }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              border: '1px solid rgba(145, 158, 171, 0.16)',
              overflow: 'hidden',
              backgroundColor: "#fff"
            }}
          >
            <Box sx={{ px: 2, py:2}}>
              <Grid2 container spacing={2} justifyContent="space-between">
                <Grid2 size={{ xs: 12, md: 4}}>
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600, color: "#212b36", fontSize: "1rem" }}>
                      Confirm Picking
                    </Typography>
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 4 }} justifyContent="flex-end">
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Search orders..."
                    value={searchInputValue}
                    onChange={handleSearchChange}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Iconify icon="eva:search-outline" width={20} height={20} sx={{ color: "#637381" }} />
                          </InputAdornment>
                        )
                      }
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f5f7fa",
                        "&:hover": {
                          backgroundColor: "#fff"
                        },
                        "&.Mui-focused": {
                          backgroundColor: "#fff"
                        }
                      }
                    }}
                  />
                </Grid2>
                <Grid2
                  item size={{ xs: 12, md: 4}}
                  sx={{
                    display: "flex",
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: 1.5
                  }}
                >
                  <Box sx={{ width: { xs: '100%', md: '350px' } }}>
                      <CommonDatePicker
                      fullWidth
                        value={salesDates}
                        onChange={(value) => {
                          setSalesDates(value);
                          if (value && value[0] && value[1]) {
                            setTimeout(() => {
                              handleSubmitDates(value);
                            }, 100);
                          }
                        }}
                 
                      />
                    </Box>
           
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleConfirmOrders}
                    disabled={selectedCount === 0}
                    sx={{
                      width: { xs: '100%', md: 'auto' },
                      textTransform: "none",
                      fontWeight: 600,
                      px: 2.5,
                      boxShadow: "none",
                      whiteSpace: "nowrap",
                      "&:hover": {
                        boxShadow: "none"
                      },
                      "&:disabled": {
                        opacity: 0.48
                      }
                    }}
                  >
                    {selectedCount > 1 ? "Bulk Confirm" : "Confirm"}
                  </Button>
                </Grid2>
              </Grid2>
            </Box>
            <TableContainer
              sx={{
                width: "100%",
                overflowX: "hidden",
                overflowY: "hidden",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              <Table
                size="medium"
                sx={{
                  tableLayout: "auto",
                  "& .MuiTableCell-root": { borderBottomColor: "rgba(145, 158, 171, 0.16)" },
                  "& .MuiTableCell-paddingCheckbox": {
                    width: 52,
                    minWidth: 52,
                    px: 0.4,
                    py: 0.4,
                  }
                }}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f7fa" }}>
                    <TableCell padding="checkbox">
                      {(() => {
                        const selectableOrdersOnPage = newSales.filter(order => order.invoice_total && Number(order.invoice_total) !== 0);
                        const allSelectedOnPage = selectableOrdersOnPage.length > 0 && 
                          selectableOrdersOnPage.every(order => selectedOrders.includes(order.id));
                        const someSelectedOnPage = selectableOrdersOnPage.some(order => selectedOrders.includes(order.id));
                        
                        return (
                          <Checkbox
                            indeterminate={someSelectedOnPage && !allSelectedOnPage}
                            checked={allSelectedOnPage}
                            onChange={handleSelectAll}
                            size="small"
                          />
                        );
                      })()}
                    </TableCell>
                    {[
                      "Invoice Date",
                      "Order Id",
                      "Customers (Account No)",
                      "Route",
                      "Delivery Date",
                      "Invoice Amt",
                      "Status",
                      "Action"
                    ].map((header) => {
                      let align = "left";
                      if (header === "Invoice Date" || header === "Order Id" || header === "Route" || header === "Delivery Date" || header === "Status" || header === "Action") {
                        align = "center";
                      } else if (header === "Invoice Amt") {
                        align = "right";
                      }
                      return (
                        <TableCell
                          key={header}
                          align={align}
                          sx={{
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            color: '#212b36',
                            userSelect: 'none',
                            letterSpacing: 0.5,
                            py: 1,
                          }}
                        >
                          {header}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    Array.from({ length: 5 }).map((_, index) => (
                      <TableRow key={index}>
                        <TableCell colSpan={9}>
                          <Skeleton height={40} />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : newSales.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                          No records found.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    newSales.map((row) => {
                      const isSelectable = row.invoice_total && Number(row.invoice_total) !== 0;
                      const isSelected = selectedOrders.includes(row.id);
                      const NotAllowed = roleID === '20';
                      const url = accessToken === 'sdm'
                        ? `${config.BASE_URL}/edit/proforma_sdm/${row.id}`
                        : `${config.BASE_URL}/edit/proforma/${row.id}`;

                      return (
                        <TableRow
                          key={row.id}
                          hover
                          sx={{
                            "&:hover": {
                              backgroundColor: "rgba(145, 158, 171, 0.04)"
                            },
                            borderBottom: "1px solid rgba(145, 158, 171, 0.16)"
                          }}
                        >
                          <TableCell padding="checkbox">
                            {isSelectable ? (
                              <Checkbox
                                checked={isSelected}
                                onChange={() => handleCheckboxChange(row.id)}
                                size="small"
                              />
                            ) : null}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            {row.invoice_date}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            {NotAllowed ? (
                              <Typography sx={{ color: "#f14240" }}>
                                {row.reference_no}
                              </Typography>
                            ) : (
                              <MuiLink
                                href={url}
                                sx={{
                                  color: "inherit",
                                  textDecoration: "underline !important",
                                  textDecorationColor: "currentColor",
                                  textUnderlineOffset: "2px",
                                  "&:hover": {
                                    textDecoration: "underline !important",
                                    textDecorationColor: "currentColor"
                                  }
                                }}
                              >
                                {row.reference_no}
                              </MuiLink>
                            )}
                          </TableCell>
                          <TableCell 
                            align="left"
                            sx={{ 
                              py: 1, 
                              fontSize: "0.75rem", 
                              color: "#212b36",
                              maxWidth: "200px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={row.customer}
                          >
                            {row.customer}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            {row.route_number}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            {row.deliverydate}
                          </TableCell>
                          <TableCell align="right" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36", fontWeight: 500 }}>
                            {row.invoice_total || ""}
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            <Chip
                              label={row.sale_status}
                              size="small"
                              color="primary"
                              sx={{
                                fontWeight: 500,
                                fontSize: '0.7rem',
                                height: 24,
                              }}
                            />
                          </TableCell>
                          <TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
                            <IconButton
                              size="small"
                              onClick={(e) => handleMenuOpen(e, row)}
                              sx={{
                                color: "#637381",
                                "&:hover": {
                                  backgroundColor: "rgba(0, 0, 0, 0.04)"
                                }
                              }}
                            >
                              <Iconify icon="eva:more-vertical-fill" width={18} height={18} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {newSales.length > 0 && (
              <Box sx={{ px: 2, py: 1.5 }} display="flex" justifyContent="flex-end" alignItems="center">
                <TablePagination
                  component="div"
                  count={totalRecords}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  sx={{
                    "& .MuiTablePagination-toolbar": {
                      flexWrap: "nowrap",
                      alignItems: "baseline",
                      minHeight: 52,
                      px: 0
                    },
                    "& .MuiTablePagination-displayedRows": {
                      marginLeft: 0
                    }
                  }}
                />
              </Box>
            )}
          </Paper>
      </Box>

      <Dialog
        open={showRejectModal}
        onClose={() => {
          setShowRejectModal(false);
          setRejectReason("");
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Reject Order
          </Typography>
          <IconButton
            onClick={() => {
              setShowRejectModal(false);
              setRejectReason("");
            }}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedOrder && (
            <>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, fontSize: '16px' }}>
                Proforma Invoice Details
              </Typography>
              <Table size="small" sx={{ mb: 3 }}>
                <TableBody>
                  <TableRow
                    sx={{
                      '& .MuiTableCell-root': {
                        fontSize: '0.75rem',
                      }
                    }}
                  >
                    <TableCell >Order Id</TableCell>
                    <TableCell>{selectedOrder.reference_no}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Customer (A/C)</TableCell>
                    <TableCell>{selectedOrder.customer}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Order Amount</TableCell>
                    <TableCell>{selectedOrder.invoice_total}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Previous Dues</TableCell>
                    <TableCell>{selectedOrder.previous_dues || "N/A"}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <TextField
                label="Reason Note"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                multiline
                minRows={3}
                fullWidth
                required
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                  },
                }}
              />
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setShowRejectModal(false);
              setRejectReason("");
            }}
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              color: '#637381',
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={updateReject}
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              backgroundColor: '#f44336',
              '&:hover': {
                backgroundColor: '#d32f2f',
              },
            }}
          >
            Update
          </Button>
        </DialogActions>
          </Dialog>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          onClick: (e) => e.stopPropagation(),
          sx: {
            minWidth: 200,
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            mt: 1,
          },
        }}
      >
        <MenuItem onClick={handleRejectAction}>
          <ListItemIcon>
            <Iconify icon="eva:close-circle-fill" width={20} height={20} />
          </ListItemIcon>
          <ListItemText>Reject Order</ListItemText>
        </MenuItem>
      </Menu>

    </div>
  );
};

export default Proforma;
